import { formsLangToLang } from 'forms-utils-lib/language/formsLangToLang';
export const translate = (I18n, text, options = {}) => {
  if (options.locale) {
    options.locale = formsLangToLang(I18n, options.locale);
  }
  return I18n.text(text, options);
};